<template>
  <div v-if="isPlanName">
    <template v-if="canEditPlanNames">
      <a href="#" @click.prevent="handleEditPlanName">
        {{ planNameDisplay }}
      </a>
    </template>
    <template v-else>
      {{ planNameDisplay }}
    </template>
    <img v-if="hasFile" src="static/img/file-mgr/pdf-small.png" style="margin-left: 3px; margin-bottom: 2px;"/>
  </div>
</template>

<script>
import Permissions from '@/utilities/permissions'
import {assemblePlanNameDisplay} from '@/utilities/utils'

export default {
  props: ['data'],
  computed: {
    isPlanName() {
      return !!(this.data && this.data.id)
    },
    hasFile() {
      return this.planName.fileId
    },
    planName() {
      if (!this.data) {
        return {}
      }
      return this.data
    },
    planNameDisplay() {
      return assemblePlanNameDisplay(this.planName)
    },
    canEditPlanNames() {
      return this.$can('edit', Permissions.PLAN_NAMES)
    }
  },
  methods: {
    handleEditPlanName() {
      this.$eventHub.$emit('show-modal-3', 'Plan Name', {id : this.planName.id}, '500px')
    }
  }
}
</script>
